import type { CreateProductionItemInput } from '@qlk/shared';
import { PRODUCTION_TOOLS, PRODUCTION_TOOL_LABEL } from '@qlk/shared';
import { useState } from 'react';

import { HopThoai, Nut, OChon } from '../../../ui/index.js';
import { useTaoItem } from '../api.js';

export interface DialogVideoMoiProps {
  kenh: { value: string; label: string }[];
  nguoiPhuTrach: { value: string; label: string }[];
  onDong: () => void;
}

export function DialogVideoMoi({ kenh, nguoiPhuTrach, onDong }: DialogVideoMoiProps) {
  const tao = useTaoItem();

  const [channelId, setChannelId] = useState(kenh[0]?.value ?? '');
  const [title, setTitle] = useState('');
  const [tool, setTool] = useState<string>(PRODUCTION_TOOLS[0]);
  const [assigneeId, setAssigneeId] = useState('');
  const [dueDate, setDueDate] = useState('');

  const hopLe = channelId !== '' && title.trim().length >= 2;

  function gui() {
    if (!hopLe) return;
    const input: CreateProductionItemInput = {
      channelId,
      title: title.trim(),
      stage: 'idea',
      tool,
      ...(assigneeId ? { assigneeId } : {}),
      ...(dueDate ? { dueDate: new Date(`${dueDate}T12:00:00+07:00`).toISOString() } : {}),
    };
    tao.mutate(input, { onSuccess: onDong });
  }

  return (
    <HopThoai
      title="Video mới"
      rong="sm"
      onDong={onDong}
      chanHop={
        <>
          {tao.isError && (
            <p role="alert" className="mr-auto self-center text-phu text-bad-chu">
              {tao.error.message}
            </p>
          )}
          <Nut kieu="phu" onClick={onDong}>
            Huỷ
          </Nut>
          <Nut kieu="chinh" disabled={!hopLe} dangChay={tao.isPending} onClick={gui}>
            Tạo thẻ
          </Nut>
        </>
      }
    >
      <p className="mt-1 text-phu text-chu-mo">Thẻ mới luôn bắt đầu ở cột Ý tưởng.</p>

      <div className="mt-4 space-y-4">
        <OChon
          hienNhan
          label="Kênh"
          value={channelId}
          onChange={setChannelId}
          options={kenh.length > 0 ? kenh : [{ value: '', label: 'Chưa có kênh nào' }]}
          className="w-full"
        />

        <div>
          <label htmlFor="tieu-de-moi" className="mb-1 block text-phu font-medium text-chu-phu">
            Tiêu đề
          </label>
          <input
            id="tieu-de-moi"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
            placeholder="Ví dụ: The lost library of Ashurbanipal"
          />
        </div>

        <OChon
          hienNhan
          label="Công cụ"
          value={tool}
          onChange={setTool}
          options={PRODUCTION_TOOLS.map((t) => ({
            value: t,
            label: PRODUCTION_TOOL_LABEL[t] ?? t,
          }))}
          className="w-full"
        />

        <OChon
          hienNhan
          label="Người phụ trách"
          value={assigneeId}
          onChange={setAssigneeId}
          options={[{ value: '', label: 'Chưa giao' }, ...nguoiPhuTrach]}
          className="w-full"
        />

        <div>
          <label htmlFor="han-moi" className="mb-1 block text-phu font-medium text-chu-phu">
            Hạn
          </label>
          <input
            id="han-moi"
            type="date"
            value={dueDate}
            onChange={(e) => {
              setDueDate(e.target.value);
            }}
            className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
          />
        </div>
      </div>
    </HopThoai>
  );
}
